





















































































































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import $ from 'jquery';

@Component
export default class Experiences extends Vue {
}
